// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6p-0";
export var startPickingButton = "_6p-1";